<template>
  <div style="height:240px">
    <div id="mm_stats_chart"></div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "MultiMediaStatsChart",
  data: () => {
    return {};
  },
  props: {},
  components: {},
  computed: {
    ...mapState(["campaign"])
  },
  mounted() {
    var options = {
      series: [
        {
          name: "Impressions",
          data: [
            this.$store.state.campaign.campaign_report.CampaignHeader
              .MultiMediaAggregates.SM_Impressions,
            this.$store.state.campaign.campaign_report.CampaignHeader
              .MultiMediaAggregates.TDA_Impressions
          ]
        }
      ],
      chart: {
        type: "bar",
        height: 250,
        stacked: false
      },
      plotOptions: {
        bar: {
          horizontal: true,
          dataLabels: {
            total: {
              enabled: true,
              offsetX: 0,
              style: {
                fontSize: "13px",
                fontWeight: 900
              }
            }
          }
        }
      },
      stroke: {
        width: 1,
        colors: ["#fff"]
      },
      title: {
        text: "Impressions"
      },
      xaxis: {
        categories: ["Social Media", "Targeted Ads"],
        labels: {
          formatter: function(val) {
            return val;
          }
        }
      },
      yaxis: {
        title: {
          text: undefined
        }
      },
      tooltip: {
        y: {
          formatter: function(val) {
            return val;
          }
        }
      },
      fill: {
        opacity: 1
      },
      legend: {
        position: "top",
        horizontalAlign: "left",
        offsetX: 40
      },
      plotOptions: {
        bar: {
          distributed: true
        }
      },
      colors: ["#e23e25DE", "#36454fDE", "#F0DC36DE", "#ADADADDE"]
    };

    var chart = new ApexCharts(
      document.querySelector("#mm_stats_chart"),
      options
    );

    chart.render();
  }
};
</script>

<style lang="scss" scoped></style>
